const isPastOrToday = (dateStr?: string): boolean => {
  if (!dateStr || dateStr === "Other") return false;

  const date = new Date(dateStr);
  if (Number.isNaN(date.getTime())) return false;
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  date.setHours(0, 0, 0, 0);
  return date <= today;
};

export const getTranslatedDurationValue = (
  value: string,
  t: (key: string) => string,
  separator = " ",
): string | undefined => {
  if (!value.includes("week") && !value.includes("months")) return value;
  const parts = value.split(separator);
  parts[1] = t(parts[1]);
  return parts.join(separator);
};

export default isPastOrToday;
